import React, { useEffect, useRef, useState } from "react";
import { Target, Eye, ShieldCheck, HeartHandshake, Lightbulb, Users } from "lucide-react";

function Nosotros() {
  const valores = [
    { icon: <ShieldCheck className="w-8 h-8 text-[var(--color-accent)]" />, titulo: "Transparencia" },
    { icon: <HeartHandshake className="w-8 h-8 text-[var(--color-accent)]" />, titulo: "Confianza" },
    { icon: <Lightbulb className="w-8 h-8 text-[var(--color-accent)]" />, titulo: "Innovación" },
    { icon: <Users className="w-8 h-8 text-[var(--color-accent)]" />, titulo: "Cercanía & Compromiso" },
  ];

  const valorRefs = useRef([]);
  const [visibleFlags, setVisibleFlags] = useState(valores.map(() => false));

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.dataset.idx);
            setVisibleFlags((prev) => {
              const copy = [...prev];
              copy[idx] = true;
              return copy;
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    valorRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section id="nosotros" className="bg-white py-24">
      <div className="container max-w-5xl mx-auto px-6">
        {/* Título principal */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-[var(--color-dark)] mb-4">
            Sobre <span className="text-[var(--color-accent)]">Admify</span>
          </h2>
          <p className="text-lg opacity-80 max-w-2xl mx-auto leading-relaxed">
            Acompañamos a emprendedores y pequeñas empresas con soluciones administrativas
            y tecnológicas claras, efectivas y humanas.
          </p>
        </div>

        {/* Misión y Visión */}
        <div className="grid md:grid-cols-2 gap-10 mb-20">
          <div className="card p-8 flex flex-col items-center text-center shadow-md hover:shadow-lg transition hover:translate-y-1">
            <Target className="w-10 h-10 text-[var(--color-accent)] mb-4" />
            <h3 className="text-2xl font-semibold mb-3">Misión</h3>
            <p className="text-base opacity-90 leading-relaxed">
              Nuestra misión es acompañar a los emprendedores en su crecimiento,
              brindando herramientas claras y efectivas para que puedan enfocarse
              en lo que realmente les apasiona.
            </p>
          </div>

          <div className="card p-8 flex flex-col items-center text-center shadow-md hover:shadow-lg transition hover:translate-y-1">
            <Eye className="w-10 h-10 text-[var(--color-accent)] mb-4" />
            <h3 className="text-2xl font-semibold mb-3">Visión</h3>
            <p className="text-base opacity-90 leading-relaxed">
              Ser una plataforma integral que conecte la administración tradicional
              con soluciones tecnológicas innovadoras, logrando que cada cliente
              sienta que tiene un socio estratégico en su negocio.
            </p>
          </div>
        </div>

        {/* Valores */}
        <div className="text-center mb-20">
          <h3 className="text-2xl font-semibold mb-8 text-[var(--color-dark)]">Nuestros Valores</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 justify-items-center">
            {valores.map((val, idx) => (
              <div
                key={idx}
                ref={(el) => (valorRefs.current[idx] = el)}
                data-idx={idx}
                className={`flex flex-col items-center justify-center gap-3 bg-[var(--color-bg)] p-6 rounded-xl shadow-sm hover:shadow-md hover:translate-y-1 transition min-h-[160px] h-full w-full max-w-[200px]
                  fade-in ${visibleFlags[idx] ? "visible" : ""}`}
              >
                {val.icon}
                <span className="font-medium text-[var(--color-dark)]">{val.titulo}</span>
              </div>
            ))}
          </div>
        </div>

<div className="bg-[var(--color-bg)] p-10 rounded-2xl shadow-sm text-center max-w-4xl mx-auto">
  <h3 className="text-2xl font-semibold mb-6 text-[var(--color-dark)]">Nuestra forma de trabajar</h3>
  <p className="text-base opacity-90 leading-relaxed mb-4">
    En Admify creemos en el poder de las conexiones. Cada cliente, cada proyecto y cada idea 
    representa una oportunidad de crear soluciones reales que simplifiquen la gestión 
    y potencien el crecimiento.
  </p>
  <p className="text-base opacity-90 leading-relaxed mb-4">
    Nos apoyamos en una red de profesionales de confianza — contadores, diseñadores, 
    programadores y especialistas en comunicación — para construir equipos a medida 
    según los desafíos de cada cliente.
  </p>
  <p className="text-base opacity-90 leading-relaxed">
    Nuestro compromiso es acompañarte con claridad, innovación y cercanía, 
    siendo ese socio estratégico que tu negocio necesita para avanzar con solidez.
  </p>
</div>


      </div>
    </section>
  );
}

export default Nosotros;


